import BasicContainer from "./BasicContainer";
import BasicFooter from "./Components/BasicFooter";
import BasicHeaders from "./Components/BasicHeaders";
import Core from "./Components/Core/Core";
import FilterPlusActions from "./Components/FilterPlusActions/FilterPlusActions";
import BasicHeader from "./Components/Header";

const BasicLayout = ({
  header,
  plusActions,
  headersData,
  coreData,
  fullArray,
  overflowX,
  fixedWidth,
  plusActionsGrid,
  onPaginationChange,
  noRecursive,
  filterSize,
  advancedFilter,
  advancedFilterModal,
}) => {
  return (
    <BasicContainer {...{ overflowX, fixedWidth }}>
      <BasicHeader>{header}</BasicHeader>
      <FilterPlusActions {...{noRecursive, plusActionsGrid, filterSize, advancedFilter, advancedFilterModal}}>
        {plusActions}
      </FilterPlusActions>
      {headersData ? (
        <BasicHeaders {...headersData} {...{ fullArray }} />
      ) : null}
      <Core hasHeaders={!!headersData} {...coreData} />
      <BasicFooter {...{ onPaginationChange }} />
    </BasicContainer>
  );
};

export default BasicLayout;
